import GrowthAcquisitionExperiments from 'bundles/epic/clients/GrowthAcquisition';
import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import SearchExperiments from 'bundles/epic/clients/search';

export const getShouldShowProductCardDensitySkills = () =>
  GrowthDiscoveryExperiments.preview('cSerpProductCardDensitySkills');
export const getShouldShowProductCardDensitySkillsWithImpression = () =>
  GrowthDiscoveryExperiments.get('cSerpProductCardDensitySkills');
export const getShouldShowProductCardDensityRating = () =>
  GrowthDiscoveryExperiments.preview('cSerpProductCardDensityRating');
export const getShouldShowProductCardDensityRatingWithImpression = () =>
  GrowthDiscoveryExperiments.get('cSerpProductCardDensityRating');

// new autocomplete
export const getShowNewAutocomplete = () =>
  GrowthDiscoveryExperiments.preview('showNewAutocomplete') ||
  GrowthDiscoveryExperiments.preview('showNewAutocompleteDogfooding');
export const impressIntoNewAutocompleteExperiment = () => GrowthDiscoveryExperiments.get('showNewAutocomplete');

// filter experiment utils
export const impressIntoFilterExperiment = () => SearchExperiments.get('serpFilterVariant');
export const isInFilterTestVariant = () => SearchExperiments.preview('serpFilterVariant');
// end filter variant utils

export const getShowNewSERPSuggestedSearch = () => GrowthDiscoveryExperiments.get('showNewSERPSuggestedSearch');

// Browse in SERP experiment utils
export const getShouldShowBrowseInSERP = () => GrowthDiscoveryExperiments.preview('showBrowseInSerp');
export const getShouldShowBrowseInSERPWithImpression = () => GrowthDiscoveryExperiments.get('showBrowseInSerp');

export const getSuggestionsSearchEngine = (isValidSearchSuggestionExperimentPage: boolean) => {
  if (isValidSearchSuggestionExperimentPage) {
    return SearchExperiments.get('suggestionsSearchEngine');
  }
  return null;
};

export const getConsumerProductsSearchHeavyRanker = () => SearchExperiments.get('consumerProductsSearchHeavyRanker');

export function impressCoachInSearch() {
  GrowthDiscoveryExperiments.get('coachInSearch');
}

export function showCoachInSearch(): boolean {
  return GrowthDiscoveryExperiments.preview('coachInSearch') !== 'control';
}

export const getShowRegistrationGate = () => GrowthAcquisitionExperiments.get('showRegistrationGate');

export const getAutoApplyFilters = () => SearchExperiments.preview('autoApplyFilters');
export const getAutoApplyFiltersWithImpression = () => SearchExperiments.get('autoApplyFilters');
